/* ==========================================================================
   PrettyRobes — Shoulder Bags collection section
   Scoped to .sb-page so listeners cannot collide with Dawn / pr-product1.js
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root) return;

    // Filter panel toggle
    var filterToggle = root.querySelector('.filter-toggle');
    var filtersPanel = root.querySelector('.filters');
    if (filterToggle && filtersPanel) {
      filterToggle.addEventListener('click', function () {
        var open = filtersPanel.dataset.open === 'true';
        filtersPanel.dataset.open = String(!open);
        filterToggle.setAttribute('aria-expanded', String(!open));
      });
    }

    // FAQ accordion
    root.querySelectorAll('.faq-item').forEach(function (item) {
      var btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('aria-expanded') === 'true';
        item.setAttribute('aria-expanded', String(!open));
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    // Quick-filter chips (visual toggle only — server-side filter wiring lives
    // in the Liquid {% if %} branches around collection.url filters)
    root.querySelectorAll('.chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pressed = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', String(!pressed));
      });
    });

    // Color swatches (visual toggle)
    root.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var pressed = sw.getAttribute('aria-pressed') === 'true';
        sw.setAttribute('aria-pressed', String(!pressed));
      });
    });

    // Sort select — submits the surrounding form on change so Shopify can
    // re-render with ?sort_by=...
    var sortSelect = root.querySelector('.sort select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var form = sortSelect.closest('form');
        if (form) form.submit();
      });
    }
  
  // Trust review link → smooth scroll to reviews section
  var trustReviewLinks = root.querySelectorAll('.trust-review-link');
  trustReviewLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // Hero image + compare-card CTAs (Shop Ready-Made / Shop Custom) → smooth scroll
  // to the in-page product grid. If a CTA points to a real URL instead of a #anchor,
  // the href guard below skips it so normal navigation still works.
  root.querySelectorAll('.hero-scroll-link, .compare-card .cta').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });

  // Load More — Ajax-append next page of products without reloading the page.
  // Scoped strictly to the product grid (.grid-section .load-more) so the
  // reviews "Read all reviews on Etsy" link is left alone.
  var lmWrap = root.querySelector('.grid-section .load-more[data-products-load-more]');
  if (lmWrap) {
    lmWrap.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-load-more-link]');
      if (!link) return;
      e.preventDefault();
      if (link.dataset.loading === 'true') return;

      var url = link.getAttribute('href');
      var grid = root.querySelector('.grid-section .grid');
      var countEl = root.querySelector('.grid-section .count');
      if (!url || !grid) { window.location.href = url; return; }

      var originalHTML = link.innerHTML;
      link.dataset.loading = 'true';
      link.setAttribute('aria-busy', 'true');
      link.innerHTML = 'Loading…';

      fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { if (!res.ok) throw new Error('Network'); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.sb-page .grid-section .grid');
          var newLm   = doc.querySelector('.sb-page .grid-section .load-more[data-products-load-more]');
          var newCount = doc.querySelector('.sb-page .grid-section .count');

          if (newGrid) {
            var frag = document.createDocumentFragment();
            Array.prototype.forEach.call(newGrid.children, function (card) {
              frag.appendChild(card.cloneNode(true));
            });
            grid.appendChild(frag);
          }

          if (countEl && newCount) {
            var shown = grid.querySelectorAll('.card').length;
            var newText = newCount.textContent.trim();
            var m = newText.match(/^([\s\S]*?)(\d+)\s*[–-]\s*(\d+)([\s\S]*)$/);
            if (m) {
              countEl.textContent = m[1] + '1–' + shown + m[4];
            }
          }

          if (newLm && newLm.querySelector('a[data-load-more-link]')) {
            lmWrap.innerHTML = newLm.innerHTML;
          } else {
            lmWrap.parentNode.removeChild(lmWrap);
          }
        })
        .catch(function () {
          link.dataset.loading = 'false';
          link.removeAttribute('aria-busy');
          link.innerHTML = originalHTML;
          window.location.href = url;
        });
    });
  }
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.sb-page').forEach(init);
    });
  } else {
    document.querySelectorAll('.sb-page').forEach(init);
  }
})();
